import { useState } from 'react';

type PreviewType = 'text' | 'image' | 'flex';

/**
 * LINE 官方帳號訊息預覽器：模擬手機上圖文選單、Flex Message 顯示
 */
export function LineMessagePreviewTool() {
  const [previewType, setPreviewType] = useState<PreviewType>('text');
  const [text, setText] = useState('您好！這是預覽訊息。');
  const [imageUrl, setImageUrl] = useState('');

  return (
    <>
      <div className="mb-6 rounded-lg border border-gray-200 bg-white p-6 dark:border-gray-700 dark:bg-gray-800">
        <div className="mb-4 flex flex-wrap gap-2">
          {(['text', 'image', 'flex'] as const).map(type => (
            <button
              key={type}
              type="button"
              onClick={() => setPreviewType(type)}
              className={`rounded px-4 py-2 text-sm font-medium ${
                previewType === type
                  ? 'bg-primary text-white'
                  : 'bg-gray-200 text-gray-700 dark:bg-gray-600 dark:text-gray-300'
              }`}
            >
              {type === 'text' && '文字'}
              {type === 'image' && '圖片'}
              {type === 'flex' && 'Flex'}
            </button>
          ))}
        </div>
        {previewType === 'text' && (
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
              訊息內容
            </label>
            <textarea
              value={text}
              onChange={e => setText(e.target.value)}
              rows={3}
              className="w-full rounded border border-gray-300 bg-white px-3 py-2 text-gray-900 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100"
            />
          </div>
        )}
        {previewType === 'image' && (
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
              圖片網址
            </label>
            <input
              type="url"
              value={imageUrl}
              onChange={e => setImageUrl(e.target.value)}
              placeholder="https://..."
              className="w-full rounded border border-gray-300 bg-white px-3 py-2 text-gray-900 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100"
            />
          </div>
        )}
        {previewType === 'flex' && (
          <p className="text-sm text-gray-600 dark:text-gray-400">
            可在此預留 Flex Message JSON 編輯與預覽（開發中）。
          </p>
        )}
      </div>

      <div className="mb-6">
        <h2 className="mb-3 text-sm font-medium text-gray-700 dark:text-gray-300">
          手機預覽
        </h2>
        <div className="mx-auto flex max-w-[320px] justify-center rounded-3xl border-4 border-gray-800 bg-gray-900 p-3 shadow-xl">
          <div className="w-full rounded-2xl bg-white dark:bg-gray-950">
            <div className="border-b border-gray-200 px-4 py-3 dark:border-gray-700">
              <p className="text-center text-xs font-medium text-gray-500 dark:text-gray-400">
                LINE 官方帳號
              </p>
            </div>
            <div className="min-h-[200px] p-4">
              {previewType === 'text' && (
                <div className="rounded-lg bg-green-100 px-3 py-2 text-sm text-gray-900 dark:bg-green-900/30 dark:text-gray-100">
                  {text || '（無內容）'}
                </div>
              )}
              {previewType === 'image' && (
                <div className="rounded-lg border border-gray-200 dark:border-gray-600">
                  {imageUrl ? (
                    <img
                      src={imageUrl}
                      alt="預覽"
                      className="max-h-48 w-full rounded-lg object-contain"
                      onError={e => {
                        e.currentTarget.src = '';
                        e.currentTarget.alt = '無法載入圖片';
                      }}
                    />
                  ) : (
                    <div className="flex h-32 items-center justify-center text-sm text-gray-400">
                      輸入圖片網址
                    </div>
                  )}
                </div>
              )}
              {previewType === 'flex' && (
                <div className="rounded border border-dashed border-gray-300 p-4 text-center text-sm text-gray-500 dark:border-gray-600 dark:text-gray-400">
                  Flex Message 預覽開發中
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <section className="rounded-lg border border-gray-200 bg-white p-6 dark:border-gray-700 dark:bg-gray-800">
        <h2 className="mb-3 text-lg font-semibold text-gray-900 dark:text-gray-100">
          使用說明
        </h2>
        <p className="leading-relaxed text-gray-600 dark:text-gray-400">
          模擬 LINE 官方帳號訊息在手機上的顯示，支援文字、圖片與圖文選單／Flex
          Message 預覽，方便在開發時檢查版型與內容。
        </p>
      </section>
    </>
  );
}
